import { EnumDescriptions } from '@/app/shared/utils';
import { i18n } from '@/plugins';

export enum TrackingEnum {
  Send = 1,
  Pending = 2,
  Undeliverable = 3,
  Delivered = 4,
  Expired = 5,
  Rejected = 6,
  Failed = 7,
  Opened = 8,
  Clicked = 9,
  TwoWay = 10,
  Unknown = 11,
  Unsubscribed = 12,
}
EnumDescriptions.setDescriptions(TrackingEnum, [
  i18n.t('enums.tracking.send'),
  i18n.t('enums.tracking.pending'),
  i18n.t('enums.tracking.undeliverable'),
  i18n.t('enums.tracking.delivered'),
  i18n.t('enums.tracking.expired'),
  i18n.t('enums.tracking.rejected'),
  i18n.t('enums.tracking.failed'),
  i18n.t('enums.tracking.opened'),
  i18n.t('enums.tracking.clicked'),
  i18n.t('enums.tracking.twoWay'),
  i18n.t('enums.tracking.unknown'),
  i18n.t('enums.tracking.unsubscribed'),
]);
